import NavButton from "../NavButton/NavButton";
import ThemeToggle from "./ThemeToggle";
import "./header.css";

const Header = ({ title, showThemeToggle = true, buttons = [] }) => {
  return (
    <header className="header">
      {title && <h1 className="header-title">{title}</h1>}

      {buttons.map((button, index) => (
        <NavButton
          key={index}
          to={button.to}
          label={button.label}
          spots={button.spots}
        />
      ))}

      <ThemeToggle />
    </header>
  );
};

export default Header;
